import React, {Fragment} from 'react'

const Form = (props) => {
    const {searchText, saveSearchText, spinnerSelect, saveSpinnerSelect, saveMessage, saveResult, saveLoading} = props
   
  
    
    
    const searchWeather = (e)=>{
        
        e.preventDefault();
        saveMessage('')
        saveResult({})
        if (searchText === '' || spinnerSelect === ''){
                     
            saveMessage('Todos los campos son obligatorios')
           
            return;
        }
        
        saveLoading(true)
        fetchApiWeather(searchText, spinnerSelect);
    }

   
    function fetchApiWeather(city,country){
    
        const yourApiKey=process.env.REACT_APP_API_WEATHER;
        const url=`https://api.openweathermap.org/data/2.5/weather?q=${city},${country}&appid=${yourApiKey}`;
        
    
        fetch(url)
            .then(result =>{
                return result.json();
            })
            .then(result =>{
                
                if(result.cod === "404"){
                    saveMessage('Locación no encontrada')
                                     
                    return;
                }
                saveMessage('')
                saveResult(result)
                
                
            
                

            
            })
            .catch(error =>{
               
                console.log(error)
            })

    }

 





    return ( 
            <Fragment>
                
            <div className="container mx-auto ">
           
            <div className="max-w-lg mx-auto ">
               
                
                
                <form onSubmit={searchWeather}
                id="formulario" className="mt-10" >
                    <div className="mt-5">
                        <input 
                            type="text" 
                            name="ciudad"
                            id="ciudad"
                            placeholder="Escribe tu Ciudad"
                            className="w-full p-2 rounded"
                            onInput={e=>saveSearchText(e.target.value)}
                        />
                    </div>
                    <div className="mt-5">
                        <select 
                            className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" 
                            id="pais"
                            onInput={e=>saveSpinnerSelect(e.target.value)}
                        >
                            <option disabled selected value="">-- Seleccione --</option>
                            <option value="AR">Argentina</option>
                            <option value="CO">Colombia</option>
                            <option value="CR">Costa Rica</option>
                            <option value="ES">España</option>
                            <option value="US">Estados Unidos</option>
                            <option value="MX">México</option>
                            <option value="PE">Perú</option>
                        </select>
                    </div>

                    <input 
                        type="submit"
                        className="mt-5 w-full bg-yellow-500 p-3  uppercase font-bold cursor-pointer rounded"
                        value="Obtener Clima"
                    />

                </form>

        
            </div>
        </div>

    </Fragment>

        );
}
 
export default Form;